/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Ocop_DecisionInputs */

const vi_shop_ocop_decision = /** @type {(inputs: Shop_Ocop_DecisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quyết định công nhận`)
};

/**

* @param {Shop_Ocop_DecisionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_ocop_decision = /** @type {((inputs?: Shop_Ocop_DecisionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Ocop_DecisionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_ocop_decision(inputs)
});